<template>
    <div class="mb-0" id="mainHeader">
        <!-- <div v-if="displayModalJackpot">
            <modal-jackpot @openclosedmodal="openjackpot" v-bind:skin="skin" />
        </div> -->
        <nav class="navbar my-0 navbar-expand-lg bg-body-tertiary" :style="skin.header_desktop.nav_bar">
            <div class="container-fluid my-0">
                <div class="float-left" @click="change_view('lobby')" style="cursor:pointer;">
                    <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                        :width="skin.header_desktop.logo_width" alt="" style="max-width: 170px;max-height: 45px;">
                </div>
                <div class="zeus-navigation" id="navbarText" ref="menuContainer">
                    <div class="">
                        <ul id="menu-zeus" ref="menuList" class="nav nav-tabs" :style="active_item">
                            <li v-for="item in visibleMenuCategories" :key="item.category" ref="menuItem" ref-in-for
                                @click="change_view(item.category)"
                                class="nav-item" role="presentation">
                                <button :class="['nav-link', 'text-center', { active: isActive(item) }]" type="button"
                                    style="text-transform: uppercase;">
                                    <span>{{ translate(item.name) }}</span>
                                </button>
                            </li>
                            <li v-if="overflowMenuCategories.length" ref="menuOverflow" class="nav-item dropdown menu-overflow">
                                <button :class="['nav-link', 'menu-overflow__toggle', { active: hasActiveOverflowCategory }]"
                                    type="button" :aria-expanded="String(overflowMenuOpen)" @click="toggleOverflowMenu"
                                    aria-label="Mostrar más opciones de navegación">
                                    <i class="fas fa-ellipsis-h"></i>
                                    <i class="fas fa-chevron-down menu-overflow__chevron"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end menu-overflow__menu" :class="{ show: overflowMenuOpen }">
                                    <li v-for="item in overflowMenuCategories" :key="item.category">
                                        <button class="dropdown-item menu-overflow__item" :class="{ active: isActive(item) }"
                                            type="button" @click="selectOverflowCategory(item.category)">
                                            {{ translate(item.name) }}
                                        </button>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                </div>
                <div v-if="user.token != ''" class="d-flex align-items-center">
                    <!-- <button v-if="skin.jackpot" @click="openjackpot" class="jackpot-btn gold-glow"
                        :style="{ '--color': skin.header_desktop.jackpot[0], '--color1': skin.header_desktop.jackpot[1], '--colorletter': skin.header_desktop.jackpot[2] }">Jackpot</button> -->
                    <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="payment"
                        :style="skin.header_desktop.login_btn"
                        class="btn btn-sm text-end mx-1 d-flex align-items-center">
                        <i class="fas fa-plus fa-fw me-1" style="font-size: 14px;"></i> <!-- Ícono de depósito -->
                        <span style="font-size: 12px;">DEPOSIT</span> <!-- Texto de depósito -->
                    </div>

                    <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="withdraw"
                        :style="skin.header_desktop.login_btn"
                        class="btn btn-sm text-end mx-1 d-flex align-items-center">
                        <i class="fas fa-minus fa-fw me-1" style="font-size: 14px;"></i> <!-- Ícono de retiro -->
                        <span style="font-size: 12px;">WITHDRAW</span> <!-- Texto de retiro -->
                    </div>

                    <a v-if="user.user_data?.data?.parentPhone"
                        :href="'https://api.whatsapp.com/send?phone=' + user.user_data?.data?.parentPhone"
                        id="whatsapp_btn" class="float btn" target="_blank">
                        <img id="whatsapp_logo" class="" src="../../../assets/images/whatsappBtn.png" alt=""
                            width="28px">
                    </a>
                    <button v-if="skin.my_account.myaccount_type == 'JM' && user.user_data?.data.cuenta"
                        class="btn btn-sm text-end mx-1 d-flex align-items-center jackpot-btn"
                        :style="recargarBtnStyle" @click="openContactAgent">
                        <span style="font-size: 12px;">RECARGAR</span>
                    </button>
                    <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.support"
                        class="dropdown nav-item ">
                        <div>
                            <div class="btn-support"
                                :style="skin.header_desktop.support_btn + (this.message_recived ? 'color:white;' : '')"
                                @click="openSupportModalJivo()">
                                <i class="fas fa-comment fa-fw"></i>
                            </div>
                        </div>
                    </div>
                    <div v-if="skin.header_desktop.balance" @click="showBalanceAction" class="nav-item mx-1"
                        :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                        :style="skin.header_desktop.nav_bar_text" style="cursor:pointer">
                        <span class="pr-0 mx-1" style="font-weight: 300;cursor:pointer;">{{
                            user.user_data?.data?.currency == 'USD' ? user.user_data?.data?.currency :
                                translate('credits')
                            }}</span>
                        <!-- <i  class="fas fa-coins pr-0 mx-1"></i> -->
                        <span style="font-weight: 800;">{{ user.user_data.data ? new
                            Intl.NumberFormat("de-DE", {
                                minimumFractionDigits:
                                    skin.qBet_config.decimalsQty, maximumFractionDigits:
                                    skin.qBet_config.decimalsQty
                            }).format(balance.saldo) : 0 }}</span>
                    </div>
                    <gamanza-account-dropdown v-if="showGamanzaProfileDropdown" :skin="skin" :language="language"
                        :user="user" :balance="balance.saldo" :show-standard-bonus-balances="false" class="mx-1"
                        @navigate-gamanza-page="change_view" />
                    <gamanza-avatar v-else-if="showGamanzaAvatar" :skin="skin" :language="language" show-summary class="mx-1"
                        @open-missions="openMissions" @open-tournaments="openTournaments"
                        @open-reward-shop="openRewardShop" />
                    <div v-if="!showGamanzaAvatar" class="user-info mx-1">
                        <div class="avatar px-1 py-1 pb-0">
                            <i class="fa fa-user fa-2x fa-inverse "></i>
                        </div>
                    </div>
                    <div class="dropdown mx-1">
                        <button class="btn btn-dark dropdown-toggle border-radiu btn-sm" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false" style="border-radius:10px">
                            <span style="margin: 20px; font-weight:800"> {{ user.user_data.data ?
                                user.user_data.data.user_name : '' }}</span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-lg-end">
                            <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.loginHistory"
                                    data-bs-toggle="modal" data-bs-target="#historial_ingresos" class="dropdown-item"
                                    href="#"><i class="fa fa-database"></i> {{ translate('option_user') }}</a></li>
                            <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                    id="changePasswordBtn" data-bs-toggle="modal" data-bs-target="#changePasswordJm"
                                    class="dropdown-item" href="#"><i class="fa fa-key"></i>
                                    {{ translate('change_password') }}</a></li>
                            <li><a v-if="skin.header_desktop.userMenu.balanceHistory" @click="getMovements()"
                                    data-bs-toggle="modal" data-bs-target="#myAccountZeus" class="dropdown-item"
                                    href="#"><i class="fa fa-history"></i> {{ translate('account_history') }}</a></li>
                            <li><a v-if="skin.header_desktop.userMenu.sportsRules" @click="terms" class="dropdown-item"
                                    href="#"><i class="fa fa-book"></i> {{ translate('regulations') }}</a></li>
                            <li><a v-if="skin.logout" @click="logout" class="dropdown-item" href="#"><i
                                        class="fa fa-power-off"></i> {{ translate('go_out') }}</a></li>
                        </ul>

                    </div>

                </div>
                <div>
                    <languageSelector :skin="skin" :language="language">
                    </languageSelector>
                </div>
                <div v-if="user.token == '' && skin.register" @click="register"
                    :style="skin.header_desktop.register_btn" class="btn btn-sm text-end">
                    <span style="display:table-cell;vertical-align:middle;">{{ translate("sign_in") }}</span>
                </div>
                <div v-if="user.token == '' && skin.login" @click="login" :style="skin.header_desktop.login_btn"
                    class="btn btn-sm text-end">
                    <span style="display:table-cell;vertical-align:middle;">{{ translate("log_in") }}</span>
                </div>
            </div>

        </nav>
        <div>
            <myAccountZeus v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <!-- Button trigger modal -->
            <button id="transaction_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#transaction"
                style="display:none;"></button>
            <button id="payment_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#payment"
                style="display:none;"></button>
            <button id="withdraw_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#withdraw"
                style="display:none;"></button>
            <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
                style="display:none;"></button>
            <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
                style="display:none;"></button>
            <button id="rewardShop_btn" class="btn btn-primary" data-bs-toggle="modal"
                data-bs-target="#gamanzaRewardShopModal" style="display:none;"></button>
            <button id="missions_btn" class="btn btn-primary" data-bs-toggle="modal"
                data-bs-target="#gamanzaMissionsModal" style="display:none;"></button>
            <button id="tournaments_btn" class="btn btn-primary" data-bs-toggle="modal"
                data-bs-target="#gamanzaTournamentsModal" style="display:none;"></button>
            <transaction v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <login2 v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <payment v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <withdraw v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <misDatos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <register v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <gamanza-reward-shop :skin="skin" :language="language" />
            <gamanza-missions :skin="skin" :language="language" />
            <gamanza-tournaments :skin="skin" :language="language" />
        </div>
    </div>

</template>


<script>
import ModalJackpot from "../../globaljackpot/ModalJackpot.vue";
import myAccountZeus from "./my_account.vue";
import login2 from "./login.vue";
import withdraw from "../../payments/withdraw.vue";
import payment from "../../payments/payment.vue";
import register from './register.vue';
import languageSelector from './language.vue';
import changePassword from "./changePassword.vue";
import misDatos from "./mis_datos.vue";
import transaction from "../../transaction.vue";
import GamanzaAvatar from "../../gamanza/GamanzaAvatar.vue";
import GamanzaAccountDropdown from "../../gamanza/GamanzaAccountDropdown.vue";
import GamanzaRewardShop from "../../gamanza/GamanzaRewardShop.vue";
import GamanzaMissions from "../../gamanza/GamanzaMissions.vue";
import GamanzaTournaments from "../../gamanza/GamanzaTournaments.vue";
import { getGamanzaMenuCategories } from '@/utils/gamanzaMenuCategories';
import { shouldUseGamanzaProfileDropdown } from '../../../utils/gamanzaProfileDropdown';

export default {
    name: "mainHeader2",
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            displayModalJackpot: false,
            currentView: '',
            activeColor: this.skin.prematch_all_odds.hover_fondo,
            activeTab: 'home-tab',
            showBalance: false,
            userDataLoaded: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            newMessage: false,
            supportTickets: [],
            visibleMenuCount: Number.MAX_SAFE_INTEGER,
            menuMeasureFrame: null,
            menuResizeObserver: null,
            overflowMenuOpen: false
        }
    },
    components: {
        myAccountZeus,
        payment,
        withdraw,
        login2,
        transaction,
        register,
        languageSelector,
        changePassword,
        misDatos,
        ModalJackpot,
        GamanzaAvatar,
        GamanzaAccountDropdown,
        GamanzaRewardShop,
        GamanzaMissions,
        GamanzaTournaments
    },
    methods: {
        openjackpot() {
            this.displayModalJackpot = !this.displayModalJackpot;
        },
        openRewardShop() {
            document.getElementById('rewardShop_btn').click();
        },
        openMissions() {
            document.getElementById('missions_btn').click();
        },
        openTournaments() {
            document.getElementById('tournaments_btn').click();
        },
        openContactAgent() {
            this.$root.$emit('openContactAgent');
        },
        scheduleMenuLayout() {
            if (this.menuMeasureFrame) {
                window.cancelAnimationFrame(this.menuMeasureFrame);
            }
            this.menuMeasureFrame = window.requestAnimationFrame(() => {
                this.visibleMenuCount = this.filteredCategories.length;
                this.$nextTick(this.measureMenuLayout);
            });
        },
        measureMenuLayout() {
            const container = this.$refs.menuContainer;
            const menuList = this.$refs.menuList;
            const items = this.$refs.menuItem || [];
            if (!container || !menuList || !items.length) {
                return;
            }

            const availableWidth = container.clientWidth;
            const navigationGap = parseFloat(window.getComputedStyle(menuList).columnGap) || 0;
            const itemWidths = items.map(item => item.offsetWidth);
            const totalWidth = itemWidths.reduce((total, width) => total + width, 0) + navigationGap * (itemWidths.length - 1);
            if (totalWidth <= availableWidth) {
                this.visibleMenuCount = this.filteredCategories.length;
                return;
            }

            const overflowToggleWidth = 44;
            let usedWidth = 0;
            let visibleCount = 0;
            for (const width of itemWidths) {
                const gapBefore = visibleCount ? navigationGap : 0;
                if (usedWidth + gapBefore + width + navigationGap + overflowToggleWidth > availableWidth) {
                    break;
                }
                usedWidth += gapBefore + width;
                visibleCount++;
            }
            this.visibleMenuCount = Math.max(1, visibleCount);
        },
        isActive(item) {
            let val = this.$store.getters['getInfoRouter'];
            if (val) { return item.category === val.category; }
            return;
        },
        toggleOverflowMenu() {
            this.overflowMenuOpen = !this.overflowMenuOpen;
        },
        closeOverflowMenuFromOutside(event) {
            const menuOverflow = this.$refs.menuOverflow;
            if (this.overflowMenuOpen && menuOverflow && !menuOverflow.contains(event.target)) {
                this.overflowMenuOpen = false;
            }
        },
        openSupportModalJivo() {
            const jivoElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoElement) {
                    jivoElement.style.display = 'none';
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoElement) {
                    jivoElement.style.display = 'block';
                    jivo_api.open()
                }
                setTimeout(() => {
                    jivo_api.open()
                }, 500);
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);

            }
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        transaction() {
            document.getElementById('transaction_btn').click();
        },
        payment() {
            document.getElementById('payment_btn').click();
            this.$store.dispatch('setPayment')
        },
        withdraw() {
            document.getElementById('withdraw_btn').click();
            this.$store.dispatch('setPayment2')
            this.$store.dispatch('setWithdraw')
        },
        login() {
            document.getElementById('login_btn').click();
        },
        register() {
            document.getElementById('register_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        my_account() {
            window.parent.postMessage(
                {
                    action: 'openSlider',
                    tab: 'recentBets'
                },
                '*'
            );
        },
        change_view(view) {
            this.$store.dispatch("changeView", view);
        },
        selectOverflowCategory(category) {
            this.overflowMenuOpen = false;
            this.change_view(category);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        }
    },
    computed: {
        filteredCategories() {
            const categories = this.$props.skin.categories.filter(category => category.active);
            return [...categories, ...this.gamanzaMenuCategories];
        },
        visibleMenuCategories() {
            return this.filteredCategories.slice(0, this.visibleMenuCount);
        },
        overflowMenuCategories() {
            return this.filteredCategories.slice(this.visibleMenuCount);
        },
        hasActiveOverflowCategory() {
            return this.overflowMenuCategories.some(item => this.isActive(item));
        },
        gamanzaMenuCategories() {
            return getGamanzaMenuCategories(this.skin, this.user, this.gamanzaReady, this.language);
        },
        contactDataAvailable() {
            return this.user?.user_data?.data?.cuenta ;
        },
        showGamanzaAvatar() {
            return Boolean(
                this.user?.token &&
                this.skin?.gamanza?.enabled &&
                this.skin?.gamanza?.mainFrame?.avatar &&
                this.gamanzaReady
            );
        },
        showGamanzaProfileDropdown() {
            return shouldUseGamanzaProfileDropdown({
                skin: this.skin,
                user: this.user,
                gamanzaReady: this.gamanzaReady
            });
        },
        gamanzaReady() {
            return this.$store.getters['getGamanzaReady'];
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        active_item() {
            return {
                "--background": this.$props.skin.header_desktop.nav_bar_item_hover_background,
                "--color": this.$props.skin.header_desktop.nav_bar_item_hover_color,
                "--border": this.$props.skin.header_desktop.nav_bar_item_hover_border,
            }
        },
        activeBarStyle() {
            // console.log(this.skin.header_desktop.servicios)
            return {
                backgroundColor: '1c1c1c',
                color: "#fff",
                borderBottom: `2px solid ${this.skin.header_desktop.nav_bar_text}`
            };
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        user_demo() {
            let data = this.$store.getters['getUserDataDemo'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        header_productsQty() {
            let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
            return products.filter(x => x == true).length + 1;
        },
        recargarBtnStyle() {
            const baseStyle = this.skin?.header_desktop?.login_btn;
            const goldStyle = {
                background: "linear-gradient(45deg, #c9a227, #f2d36b)",
                color: "#1c1c1c",
                boxShadow: "0 0 12px rgba(201, 162, 39, 0.45)",
                border: "none"
            };

            if (!baseStyle) {
                return goldStyle;
            }
            if (typeof baseStyle === "string") {
                return `${baseStyle}; background: linear-gradient(45deg, #c9a227, #f2d36b); color: #1c1c1c; box-shadow: 0 0 12px rgba(201, 162, 39, 0.45); border: none;`;
            }
            return Object.assign({}, baseStyle, goldStyle);
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight);
        this.$root.$on('openLogin', () => {
            this.login();
        });
        window.addEventListener('resize', this.scheduleMenuLayout);
        document.addEventListener('click', this.closeOverflowMenuFromOutside);
        this.menuResizeObserver = new ResizeObserver(this.scheduleMenuLayout);
        this.menuResizeObserver.observe(this.$refs.menuContainer);
        this.scheduleMenuLayout();
    },
    watch: {
        filteredCategories() {
            this.scheduleMenuLayout();
        },
        language() {
            this.scheduleMenuLayout();
        },
        'user.token'(newVal) {
            if (newVal !== '' && this.skin.jackpot) {
                this.openjackpot();
            }
        },
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        var saldo_request = setInterval(function () {
            try {
                if (self.user.user_data.data) {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);
    },
    beforeDestroy() {
        this.$root.$off('openLogin');
        window.removeEventListener('resize', this.scheduleMenuLayout);
        document.removeEventListener('click', this.closeOverflowMenuFromOutside);
        if (this.menuResizeObserver) {
            this.menuResizeObserver.disconnect();
        }
        if (this.menuMeasureFrame) {
            window.cancelAnimationFrame(this.menuMeasureFrame);
        }
    }
}
</script>

<style scoped>
@keyframes blink {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.05);
        /* Cambio más suave */
        opacity: 0.7;
        /* Menos agresivo */
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.jackpot-btn {
    animation: blink 1.5s infinite ease-in-out;
    transition: all 0.3s ease-in-out;
    font-size: 14px;
    padding: 6px;
    margin-right: 5px;
    font-weight: bold;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 10px;
    text-transform: uppercase;
}

.jackpot-btn:hover {
    animation: none;
}

.gold-glow {
    background: linear-gradient(45deg, var(--color), var(--color1));
    color: var(--colorletter);
    box-shadow: 0 0 15px var(--color);
}

.gold-glow:hover {
    box-shadow: 0 0 30px var(--color);
}

.container-flud {
    border-bottom: 0%;
    padding: 0;

}

.btn-support {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    min-width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}

.navbar {
    border: none;
    flex-wrap: nowrap;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: 600;
    padding-top: 0px;
    height: 52px;
    min-height: 52px;
    max-height: 52px;
    box-sizing: border-box;
    padding-bottom: 0px;
}

.navbar > .container-fluid {
    flex-wrap: nowrap;
}

.center_div {
    width: 90%;
    /* Can be in percentage also. */
    height: auto;
    margin: 0;
    padding: 0px;
    position: relative;
}

.dropdown-menu,
.dropdown-item {
    padding: 10px;
    margin-left: 10px;
    border: none;
    border-radius: 10px;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: bold;
    background-color: #1c1c1c;
    /* Color de fondo por defecto */
    color: #fff;
    /* Color del texto por defecto */
}

.nav-tabs {
    border: none !important;
}

.zeus-navigation {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    min-width: 0;
}

.zeus-navigation > div {
    min-width: 0;
}

#menu-zeus {
    flex-wrap: nowrap;
    min-width: 0;
    max-width: 100%;
    white-space: nowrap;
}

#menu-zeus .nav-item {
    flex: 0 0 auto;
}

.menu-overflow__toggle {
    display: flex;
    gap: 4px;
    align-items: center;
    padding-right: 10px;
    padding-left: 10px;
}

.menu-overflow__chevron {
    font-size: 8px;
}

.menu-overflow__menu {
    min-width: 150px;
    margin-left: 0;
}

.menu-overflow__item {
    width: 100%;
    margin-left: 0;
    text-align: left;
    text-transform: uppercase;
}

.menu-overflow__item.active {
    background-color: var(--background);
    color: var(--color);
    border-bottom: var(--border);
}

.btn-dark,
.avatar {
    font-size-adjust: true;
    border: 1px solid white;
    background-color: #1c1c1c;
    /* Color de fondo por defecto */
    color: #fff;
    /* Color del texto por defecto */
    border-radius: 5px 5px 5px 5px;
}

/* Estilos para los botones */
.nav-link {
    border: none;
    /* Color de fondo por defecto */
    border-bottom: 2px solid transparent;
    color: #fff;
    /* Color del texto por defecto */
    font-weight: bold;
    /* Hace que el texto sea más grueso */
    font-size: 12px "Exo 2";
    padding: 16px;

}

.nav-link.active {
    background-color: var(--background);
    color: var(--color);
    border-bottom: var(--border);
    padding: 16px;
}

/* Estilos para los botones cuando se hace hover */
.nav-link:hover {
    background-color: var(--background);
    /* Color de fondo cuando se hace hover */
    color: var(--color);
    /* Color del texto cuando se hace hover */
    border-bottom: var(--border);
}

.navbar-collapse {
    display: flex;
    align-items: center;
    /* Centra verticalmente los elementos */
    height: 100%;
    /* Establece la altura al 100% del contenedor padre */
    margin: 0;
    padding: 0;
    border: none;
}

.navbar-nav {
    width: 100%;
    /* Ocupa todo el ancho disponible */
    display: flex;
    align-items: center;
    /* Centra verticalmente los elementos */
    justify-content: end;
    /* Alinea los elementos al extremo derecho */
    margin: 0;
    padding: 0;
    border: none;
}

.navbar-nav .nav-item {
    margin-left: auto;
    /* Empuja todos los elementos al extremo derecho */
    margin: 0;
    padding: 0;
    border: none;
}
</style>
